import { PRODUCT_TYPES, ProductType } from '../../../../../../lib/consts';

export type OperationRole = 'Deudor' | 'Cliente';

export const getShortString = (string: string, maxLength: number = 25): string => {
  return string.length > maxLength
    ? string.substring(0, maxLength) + '...'
    : string;
};

export const getImageDimensionsFromBase64 = (
  base64: string,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.src = base64;
  });
};

export const getProductTypeLabel = (type: ProductType): string => {
  const found = PRODUCT_TYPES.find((t) => t.value === type);
  return found ? found.label : type;
};